import { Ass_03, Lia_12 } from "../../Chart.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const TAX_DEBT_PAYMENT: Template = {
  id: "c0342fff-54c9-4f6e-8063-6431737d04e5",
  name: "Maksuvõla tasumine EMTA-le",
  description:
    "Maksuvõlaks (Lia-12) tasumine EMTA-le. Maksuvõlg tekib tavaliselt puudujääva käibemaksu arvelt.",
  variables: [
    {
      name: "Title",
      type: "text"
    },
    {
      name: "Date",
      type: "date"
    },
    {
      name: "Amount",
      type: "amount_eur"
    }
  ],
  initialValues: [
    {
      name: "Title",
      value: "Maksuvõla tasumine EMTA-le"
    }
  ],
  generate: (values) => {
    const date = findVariableValue("Date", values);
    const amount = Math.round(parseFloat(findVariableValue("Amount", values)) * 100);

    const entry: NewEntry = {
      title: findVariableValue("Title", values),
      items: [
        {
          title: "Maksuvõla tasumine",
          date: date,
          amount: amount,
          eurAmount: amount,
          currency: "eur",
          debit: Lia_12,
          credit: Ass_03
        }
      ]
    };

    return { type: "success", entry };
  }
};
